import React from 'react';
import moment from 'moment';

const MILITARY_TIME_MASK_HM = /^([01]\d|2[0-3]):?([0-5]\d)$/;
const HMRegex = RegExp(MILITARY_TIME_MASK_HM)

const MILITARY_TIME_MASK_HMS = /^(?:[01]\d|2[0-3]):(?:[0-5]\d):(?:[0-5]\d)$/;
const HMSRegex = RegExp(MILITARY_TIME_MASK_HMS)


/**
 * Returns ok if string matches `00:00` or `00:00:00` masks
 *
 * @param {String} value The time entered
 */
const canCommitToParent = value => (
    HMRegex.test(value) ||
    HMSRegex.test(value)
)


function charsAreValid (value) {
    const num = new RegExp(/^[0-9]+$/)
    const colon = new RegExp(/^:$/)

    for (let i = 0; i < value.length; i++) {
        const char = value[i];
        if (
            !num.test(char) &&
            !colon.test(char)
        ) return false
    }

    return true
}

class ReactClockPicker extends React.Component {

    constructor (props) {
        super(props)

        this.state = {
            pending: null
        }

        this.getValue = this.getValue.bind(this)
        this.changed = this.changed.bind(this)
    }

    componentDidMount () {
        var self = this;
        var $input = $('#' + this.props.id);
        if ($input && $input.clockpicker) {
            $input.clockpicker({
                // twelvehour: true,
                // ampmSubmit: true,
                placement: self.props.position || 'bottom'
            }).on('change', function (e) {
                e.stopPropagation();
                e.preventDefault();
                // console.log('this.val()', $(this).val())
                var value = $(this).val() !== '' ? $(this).val() + ':00' : '';
                self.changed(self.props.name, value);
            });
        }
    }

    getValue () {
        return this.refs[this.props.name].getDOMNode().value;
    }

    /**
     * @note
     *
     * two kinds of input can happen:
     *
     * via SyntheticEvent (i.e. user text input):
     *   - SynteticEvent({ event.target.value }), , null
     *
     * via $clockPicker:
     *  -  startTime, 11:00:00
     */
    changed (field, value) {

        /**
         * @note
         * If the user is inputing text we need to
         * make sure it's valid before we update the parent state.
         *
         * We also need to reject bad chars. Accepted chars are:
         *  - `00-23`
         *  - `01-59`
         *  - `:`
         */
        if (!(field instanceof Event) && typeof field !== 'string') {

            // console.log('field', field, value)

            let userValue = field.target.value

            if (charsAreValid(userValue)) {
                this.setState({
                    pending: userValue
                });

                if (canCommitToParent(userValue)) {
                    // console.log('canCommitToParent', userValue)

                    // Adds required SS to match required HH:MM:SS of the API
                    if (userValue.length === 5) userValue = `${userValue}:00`

                    let userTime = moment(userValue, 'HH:mm:ss');

                    this.setState(() => ({
                        pending: null
                    }))
                    this.props.handleChange(userTime);
                }
            }

            return
        } else {
            /**
             * Because we have managed input (value/onChange) we need to return
             * here or we'll get undefined as a variable assignment in the parent's state
             */
            if (value === undefined || value === '') return;
            let time = moment(value, 'HH:mm:ss');

            // console.log('handleChange', time)

            this.setState(() => ({
                pending: null
            }))
            this.props.handleChange(time);
        }

    }

    render () {

        let value = (moment.isMoment(this.props.value)) ?
            this.props.value.format('HH:mm:ss') :
            this.props.value

        if (this.state.pending !== null) value = this.state.pending

        return <input
            type="text"
            className="form-control"
            data-autoclose="true"
            onChange={this.changed}
            placeholder={this.props.placeholder || ''}
            disabled={this.props.disabled}
            value={value || ''}
            id={this.props.id}
            name={this.props.name}
            ref={this.props.name}
        />
    }

}

export default ReactClockPicker
